import React, { useContext } from 'react';
import { AppContext } from 'src/components/app-context';
import RatingIcon from './rating-icon';
import { getSmileyRating } from './utils';
import type { Rating } from '../types';
import * as S from './styles';

type Props = {
  featured: boolean;
  rating: Rating;
  reviewCount?: number | null;
  scoreVisibility?: 'row' | 'compact';
  size?: 'small' | 'normal';
  className?: string;
};

const RatingSmiley = ({
  featured,
  rating,
  reviewCount,
  scoreVisibility,
  size = 'normal',
  className,
}: Props) => {
  const { t } = useContext(AppContext);

  const iconSize = size === 'small' ? 17 : 20;

  const smileyRating = getSmileyRating(rating.rounded);
  const label = t('reviews', 'rating.rate-n-text-version', {
    n: rating.roundedString,
  });

  if (!smileyRating) {
    return null;
  }

  return (
    <S.RatingSmiley className={className}>
      {smileyRating.iconType ? (
        <S.IconWrapper
          aria-label={label}
          data-rating={rating.roundedString}
          scoreVisibility={scoreVisibility}
          size={size}
        >
          <RatingIcon
            type={smileyRating.iconType}
            disabled={!featured}
            size={iconSize}
            ariaLabel={label}
          />
        </S.IconWrapper>
      ) : null}
      {reviewCount && (
        <S.RatingCount>
          {`(${reviewCount > 500 ? '500+' : reviewCount})`}
        </S.RatingCount>
      )}
    </S.RatingSmiley>
  );
};

export default RatingSmiley;
